/* ==========================================================================
   hov-pdp-desktop.js — desktop-only product-page behaviour (>= 992px)
   --------------------------------------------------------------------------
   Companion to assets/hov-pdp-desktop.css. Loaded (defer) by
   sections/latest-product-template.liquid and sections/product-template.liquid.

   Three jobs, all for the gallery column:
     1. Round prev/next buttons on the main image and a ZOOM pill. The gallery is
        the theme's own slick pair (.js_prod_main2 + .js_prod_sub2, initialised
        by slideProductDetail2() in assets/engo-scripts.js.liquid:349). These
        buttons only DRIVE that slider; they never re-initialise it.
     2. Keep the current thumbnail in view in the vertical rail. The rail is
        vertical by CSS only, so slick's own horizontal scrolling is switched
        off there and the rail scrolls natively instead.
     3. A sticky offset for the gallery column that never hides its bottom: a
        column taller than the viewport sticks by its bottom edge instead of
        its top.

   Nothing is injected, measured or bound below 992px, so phones and tablets
   keep exactly what they had.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__hovPdpD) return;
  window.__hovPdpD = true;

  var $ = window.jQuery;
  if (!$) return;

  var desk = window.matchMedia('(min-width: 992px)');

  var SVG = function (d) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + d + '</svg>';
  };
  var ICON_PREV = SVG('<path d="M14.5 6l-6 6 6 6"/>');
  var ICON_NEXT = SVG('<path d="M9.5 6l6 6-6 6"/>');
  var ICON_ZOOM = SVG('<circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L20 20M10.5 8v5M8 10.5h5"/>');

  var $main = $('.gallery-control .js_prod_main2').first();
  var holder = $main.length ? $main.parent('.relative')[0] : null;
  var built = false;
  var ui = {};

  /* Read the instance straight off the element. slick triggers `init` from
     inside its constructor, BEFORE it assigns element.slick, so calling
     $main.slick('getSlick') at that moment throws — and an exception there
     aborts the theme's own slider set-up (the thumbnail slick never starts). */
  function slick() {
    var el = $main[0];
    return el && el.slick ? el.slick : null;
  }

  /* ---- 1. arrows + zoom ------------------------------------------------ */
  function sync() {
    var s = slick();
    if (!s || !built) return;
    var cur = s.currentSlide, last = s.slideCount - 1;
    ui.prev.disabled = cur <= 0;
    ui.next.disabled = cur >= last;
    railToCurrent(cur);
  }

  function images() {
    var s = slick();
    var $imgs = s ? $main.find('.slick-slide:not(.slick-cloned) img') : $main.find('img');
    return $imgs.map(function () {
      var src = this.getAttribute('data-src') || this.currentSrc || this.src;
      return src ? { src: src, type: 'image', opts: { caption: this.getAttribute('alt') || '' } } : null;
    }).get();
  }

  function build() {
    if (built || !holder || !desk.matches || !slick()) return;
    var count = slick().slideCount;

    if (count > 1) {
      ui.prev = document.createElement('button');
      ui.prev.type = 'button';
      ui.prev.className = 'hov-gal__nav hov-gal__nav--prev';
      ui.prev.setAttribute('aria-label', 'Previous image');
      ui.prev.innerHTML = ICON_PREV;

      ui.next = document.createElement('button');
      ui.next.type = 'button';
      ui.next.className = 'hov-gal__nav hov-gal__nav--next';
      ui.next.setAttribute('aria-label', 'Next image');
      ui.next.innerHTML = ICON_NEXT;

      ui.prev.addEventListener('click', function () { $main.slick('slickPrev'); });
      ui.next.addEventListener('click', function () { $main.slick('slickNext'); });
      holder.appendChild(ui.prev);
      holder.appendChild(ui.next);
    }

    // The theme's own lightbox (fancyBox 3, layout/theme.liquid) — no new library.
    if ($.fancybox && typeof $.fancybox.open === 'function') {
      ui.zoom = document.createElement('button');
      ui.zoom.type = 'button';
      ui.zoom.className = 'hov-gal__zoom';
      ui.zoom.setAttribute('aria-label', 'Zoom image');
      ui.zoom.innerHTML = ICON_ZOOM + '<span>Zoom</span>';
      ui.zoom.addEventListener('click', function () {
        var list = images();
        if (!list.length) return;
        var s = slick();
        $.fancybox.open(list, { loop: true, animationEffect: 'zoom', transitionEffect: 'fade',
          buttons: ['zoom', 'thumbs', 'close'] }, s ? s.currentSlide : 0);
      });
      holder.appendChild(ui.zoom);
    }

    holder.classList.add('hov-gal');
    built = true;
    if (ui.prev) sync();
  }

  /* ---- 2. rail follows the current slide ------------------------------- */
  function railToCurrent(index) {
    if (!desk.matches) return;
    var list = document.querySelector('.gallery-control .js_prod_sub2 .slick-list');
    if (!list) return;
    var th = list.querySelector('.slick-slide[data-slick-index="' + index + '"]');
    if (!th) return;
    var top = th.offsetTop - (list.clientHeight - th.offsetHeight) / 2;
    list.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  // Never let this file break the theme's slider: every entry point is guarded
  // and deferred to after the current slick call stack has finished.
  var safe = function (fn) { return function () { try { fn(); } catch (e) { /* leave the theme gallery as it is */ } }; };

  if ($main.length) {
    // Deferred scripts run before DOMContentLoaded, so this is bound before
    // engo-scripts' document.ready initialises slick; the ready/load fallbacks
    // cover every other order.
    $main.on('init', function () { setTimeout(safe(build), 0); });
    $main.on('afterChange', function () { setTimeout(safe(function () { if (ui.prev) sync(); }), 0); });
    $(function () { setTimeout(safe(build), 0); });
    window.addEventListener('load', safe(build));
  }

  /* ---- 3. sticky gallery column ---------------------------------------- */
  var col = document.querySelector('#content .content-page-detail > .row > div:first-child');
  function stickyTop() {
    if (!col) return;
    col.style.removeProperty('--hov-gal-top');
    if (!desk.matches) return;
    var natural = parseFloat(window.getComputedStyle(col).top) || 0;
    var room = window.innerHeight - natural - 16;
    if (col.offsetHeight > room) {
      col.style.setProperty('--hov-gal-top', Math.round(window.innerHeight - col.offsetHeight - 16) + 'px');
    }
  }
  if (col) {
    var t = null;
    var later = function () { if (t) clearTimeout(t); t = setTimeout(stickyTop, 120); };
    window.addEventListener('load', stickyTop);
    window.addEventListener('resize', later, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(later).observe(col);
    stickyTop();
  }

  var onMq = safe(function () { build(); stickyTop(); });
  if (desk.addEventListener) desk.addEventListener('change', onMq);
  else if (desk.addListener) desk.addListener(onMq);
})();
